"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMapDataEndpoint = exports.getOptions = void 0;
var design_system_colors_1 = require("../../../../style/theme/design-system-colors");
var utils_1 = require("../utils");
var constants_1 = require("./constants");
var getOptions = function (data, map) { return ({
    chart: {
        map: map,
    },
    tooltip: __assign(__assign({}, utils_1.tooltipOptions), { borderRadius: 10, useHTML: true, formatter: function () {
            return utils_1.ChartTooltipFormatterFn(this.color, this.point.name, this.point.value);
        } }),
    mapNavigation: {
        enabled: true,
        buttonOptions: {
            alignTo: 'spacingBox',
        },
    },
    colorAxis: {
        minColor: design_system_colors_1.DesignSystemColor.Blue.LIGHT_3,
        maxColor: design_system_colors_1.DesignSystemColor.Blue.DARK_4,
    },
    series: [
        {
            dataLabels: { enabled: false },
            data: data,
        },
    ],
}); };
exports.getOptions = getOptions;
var getGeographicDataEndpoint = function (geographicScope, countryCode) {
    if (geographicScope === void 0) { geographicScope = ''; }
    if (countryCode === void 0) { countryCode = ''; }
    if (geographicScope === constants_1.GEOGRAPHIC_SCOPE.country && countryCode) {
        return "countries/" + countryCode + "/" + countryCode + "-all.geo.json";
    }
    return "custom/" + constants_1.GEOGRAPHIC_SCOPE.world + ".geo.json";
};
var getMapDataEndpoint = function (geographicScope, countryCode) {
    if (geographicScope === void 0) { geographicScope = constants_1.GEOGRAPHIC_SCOPE.world; }
    if (countryCode === void 0) { countryCode = ''; }
    return "https://code.highcharts.com/mapdata/" + getGeographicDataEndpoint(geographicScope, countryCode);
};
exports.getMapDataEndpoint = getMapDataEndpoint;
